import { FacilityInformationType } from '@cargos/sprintpay-services';

export const FACILITY_INFO: FacilityInformationType[] = [
    {
        airportName: 'DHL Aviation (CVG)',
        address1: '1121 Aviation Blvd. Hebron, KY 41048',
        phone: '(800) 353-1528',
        firmsCode: 'DHL: H0G1',
        position: {
            lat: 39.079656,
            lng: -84.672166,
        },
        operatingHours: [
            {
                days: 'Mon-Sun',
                hour: '8:30am - 08:00pm',
            },
        ],
        email: ['acscv2@wfs.aero'],
        awbPrefixes: ['DHL: 144, 155, 403, 615, 936, 946, 947, 992', 'ISC Charge: $130 per Mawb Hawb'],
    },
];
